import {XauditModel} from '../../../../models/xaudit.model';
import {OrganizationDataModel} from '../../../../models/organization/organization-data.model';

export class ReferralEntityModel extends XauditModel {
    ReferralEntityID: string;
    TDOCID: number;
    ReferralClientName: string;
    OrganizationID: string;
    URL: string;
    Organization: OrganizationReferralEntityModel;
    cfgReferralEntityProviderDoctors: ReferralEntityProviderDoctorsModel[];
}

export class OrganizationReferralEntityModel {
    OrganizationId: string;
    Name: string;
    ContactFullName: string;
    ContactPhone: string;
    ContactEmail: string;
    AddressUpper: string;
    AddressBottom: string;
}


export class ReferralEntityProviderDoctorsModel extends XauditModel {
    ReferralEntityDocID: string;
    ReferralEntityID: string;
    DoctorID: string;
}

export class emailInformationModel {
    emailAddress: string;
    referralContactName: string;
    url: string;
    practiceName: string;
    practiceAddressUpper: string;
    practiceAddressDown: string;
}


